// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__11pz7","text":"Content_text__226np","input":"Content_input__XavBX"};